import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  p: (p) => p.spacing(0, 1, 0.5, 1),
};
